import { PromiseWrapper } from "../../api-polyfill/src/utils/pw";
import { toGoLangInvoke } from "../../api-polyfill/src/common/windowFunctions";
export class LoggerService {
    constructor(glue, logger, router) {
        this.glue = glue;
        this.logger = logger;
        this.router = router;
        this.ready = new PromiseWrapper();
    }
    async maybeSetLogToDisk(manifest) {
        const logToDiskLevels = manifest?.["finsemble-electron-adapter"]?.logger?.logToDiskLevels;
        if (Array.isArray(logToDiskLevels)) {
            this.logger.debug("Setting central-logger logToDiskLevels", logToDiskLevels);
            const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("central-logger-set-logToDisk", {
                logToDiskLevels
            }));
            if (err) {
                this.logger.error("Error setting logToDiskLevels", err);
            }
        }
    }
    async start() {
        await this.router.onReady();
        await this.register_handlers();
    }
    async register_handlers() {
        this.router.addListener("CentralConsole-Show", async (err, { data }) => {
            if (data) {
                const allWindows = this.glue.windows.list();
                const centralLoggerWindow = allWindows.find((w) => w.name === "central-logger");
                if (centralLoggerWindow) {
                    await centralLoggerWindow.show();
                    await centralLoggerWindow.focus();
                }
                else {
                    this.glue.appManager.application("central-logger")?.start();
                }
            }
        });
        this.ready.resolve();
    }
}
